import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';

const ServicesFinalCTA = () => {
  return (
    <section id="services-final-cta" className="section-padding bg-gradient-to-r from-burnt-orange/10 to-olive-brown/10">
      <div className="container-center">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Header */}
          <div className="space-y-6">
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
              Want a lighter week and stronger follow-through?
            </h2>
            
            <p className="text-xl text-olive-brown/80 leading-relaxed">
              Choose your next step. We'll keep it simple.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <a
              href="#contact"
              className="btn-primary group inline-flex items-center justify-center"
              aria-label="Book a Quick Call - Quick chat to confirm fit + scope"
              title="Quick chat to confirm fit + scope"
            >
              Book a Quick Call
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <a
              href="#contact"
              className="btn-secondary group inline-flex items-center justify-center"
              aria-label="Request a Confidential Memo - Written plan tailored to your role"
              title="Written plan tailored to your role"
            >
              Request a Confidential Memo
              <FileText className="ml-2 h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
            </a>
          </div>

          {/* Microcopy */}
          <div className="text-center space-y-2 pt-4">
            <p className="text-sm text-olive-brown/60">
              <strong>Primary:</strong> Quick chat to confirm fit + scope.
            </p>
            <p className="text-sm text-olive-brown/60">
              <strong>Secondary:</strong> Written plan tailored to your role.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesFinalCTA;